import {
  Directive,
  inject,
  Input,
  ChangeDetectorRef,
  ComponentRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewContainerRef
} from '@angular/core';
import { PluginInjectorWidget, PluginInjectorService, IModuleWidget } from 'core-client/api';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appWidgetItem]',
  standalone: true
})
export class WidgetDirective implements OnInit, OnChanges, OnDestroy {
  @Input('appWidgetItem') widget!: PluginInjectorWidget.IWidget;
  @Input('isHeaderHovered') isHeaderHovered!: boolean;

  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private extraTitleSubscriptions: Subscription | undefined
  private componentRef!: ComponentRef<any>; // Store reference to the dynamically created component

  constructor(
    private readonly viewContainerRef: ViewContainerRef,
    private readonly pluginInjectorService: PluginInjectorService
  ) { }

  ngOnInit(): void {
    this.createDynamicWidgetComponent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle updates to the `isHeaderHovered` input
    if (changes['isHeaderHovered'] && this.componentRef) {
      this.componentRef.instance.isHeaderHovered = this.isHeaderHovered;
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    this.extraTitleSubscriptions?.unsubscribe();

    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  private createDynamicWidgetComponent(): void {
    const moduleWidgets = this.pluginInjectorService.widgetService.getModuleWidgets()
    const moduleWidget = moduleWidgets.find((widgetComponent: IModuleWidget) => widgetComponent.pluginId === this.widget.pluginId && widgetComponent.pluginModule === this.widget.pluginModule)
    if (moduleWidget?.viewComponent) {
      const componentRef = this.viewContainerRef.createComponent(moduleWidget.viewComponent.component)
      this.componentRef = componentRef;  // Assigning the componentRef correctly

      // Set the `isHeaderHovered` input for the dynamically created component
      componentRef.instance.isHeaderHovered = this.isHeaderHovered ? this.isHeaderHovered : false;

      componentRef.instance.data = {
        appPluginWidget: this.widget.appPluginWidget,
        pluginId: this.widget.pluginId,
        pluginModule: this.widget.pluginModule,
        widgetPermissions: moduleWidget?.widgetPermissions,
        publicView: this.widget.publicView
      } as PluginInjectorWidget.IWidget

      if (componentRef.instance.extraTitle) {
        this.extraTitleSubscriptions = componentRef.instance.extraTitle.subscribe((extraTitle: string) => {
          if (extraTitle.trim().length > 0) {
            this.widget['extraTitle'] = `: ${extraTitle}`;
          } else {
            this.widget['extraTitle'] = '';
          }
        });
      }

      this.cdr.detectChanges();
    }
  }
}
